module.exports = __webpack_public_path__ + "img/violet_019.c739a599.png";